import { render, staticRenderFns } from "./ZonaCompletaModal.vue?vue&type=template&id=61df32a1&scoped=true&"
import script from "./ZonaCompletaModal.vue?vue&type=script&lang=js&"
export * from "./ZonaCompletaModal.vue?vue&type=script&lang=js&"
import style0 from "./ZonaCompletaModal.vue?vue&type=style&index=0&id=61df32a1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61df32a1",
  null
  
)

export default component.exports